import {computed} from "vue";

/**
 * 字段编辑只读状态（xmFileUpload / ImageSelect / xmRelForm 等两参调用方专用）
 * 兼容两种调用：
 *   useFieldStateHooks({ vuex, props, model, formElAclInfos, readOnlyText })
 *   useFieldStateHooks({ vuex, props, model }, { disabledPItem, readOnlyTextPItem, formElAclInfos })
 * 流程 ACL：disabled/hidden 只影响禁用与隐藏；不写、不清控件原有 readOnlyText
 * @param props
 * @param model
 * @param formElAclInfos
 */
export function useFieldStateHooks(first: any = {}, second: any = {}) {
  const {
    vuex,
    props,
    model,
    formElAclInfos: formElAclInfosFromFirst,
    readOnlyText = false,
  } = first || {};
  const {
    disabledPItem,
    readOnlyTextPItem,
    formElAclInfos: formElAclInfosFromSecond,
  } = second || {};

  const formElAclInfos = formElAclInfosFromFirst ?? formElAclInfosFromSecond;
  const readOnlyTextMerged = readOnlyText || readOnlyTextPItem || false;

  /** 流程 ACL 状态：model.key（业务字段名，白名单授权键）优先，其次 props.key（设计器元素键） */
  const getAclState = (aclMap: any) => {
    if (!aclMap) return null;
    const propsKey = unref(props)?.key;
    const modelKey = unref(model)?.key;
    if (modelKey != null && modelKey !== '' && aclMap[modelKey] != null) {
      return aclMap[modelKey];
    }
    if (propsKey != null && propsKey !== '' && aclMap[propsKey] != null) {
      return aclMap[propsKey];
    }
    return null;
  };

  const disabledState = computed(() => {
    //如果存在授权 则优先级最高（hidden 同样视为不可编辑）
    const aclState = getAclState(unref(formElAclInfos));
    if (aclState === 'disabled' || aclState === 'hidden') {
      return true;
    }
    //如果存在变量控制 优先级第二（高于 canEditorVal）
    if (unref(props)['disabledVuex']) {
      return vuex.value['disabled'];
    }
    //只有是父节点打开了 只读和不可编辑 才需要执行（优先级第三）
    if ((unref(disabledPItem)||unref(readOnlyTextPItem))&&unref(props).canEditorVal) {
      return false;
    }
    //读取父节点的disabled属性
    return unref(props).disabled || unref(disabledPItem)||unref(readOnlyTextPItem) || false;
  });


  /**
   * 只读文本态。优先级从高到低：
   * 1. 流程权限不改只读态（ACL 只控制 disabled/hidden）
   * 2. 动态绑定：配置了 readOnlyTextVuex 则只取绑定结果，true/false 都直接返回
   * 3. props 自身 readOnly / readOnlyText / 父节点只读
   */
  const readOnlyState = computed(() => {
    if (unref(props)?.readOnlyTextVuex) {
      return (unref(vuex)?.['readOnlyText'] + '') === 'true';
    }
    return unref(props).readOnly || unref(props).readOnlyText || unref(readOnlyTextMerged) || false;
  });

  /**
   * 显示/隐藏。优先级从高到低：
   * 1. 流程权限 ACL hidden
   * 2. 动态绑定：配置了 showCtlVuex 则只取绑定结果，true/false 都直接返回
   * 3. props 自身 showCtl
   */
  const hiddenState = computed(() => {
    const aclState = getAclState(unref(formElAclInfos));
    if (aclState === 'hidden') {
      return true;
    }
    if (unref(props)?.showCtlVuex) {
      return unref(vuex)?.['showCtl'];
    }
    return unref(props).showCtl;
  })

  return {
    disabledState,
    readOnlyState,
    hiddenState
  }
}
